<template>
    <div class="filter-table">
        <div class="filter-row">
            <div  class="monitoring__content-search-block">
                <input
                    @keydown.enter="sendFilterButton()"
                    v-model="searchQuery"
                    :placeholder="searchPlaceholder"
                    class="monitoring__content-search">
                    <span v-if="searchQuery" @click="()=> { searchQuery = ''; sendFilterButton(); }" class="lnr lnr-cross"></span>
                    <span @click="sendFilterButton()" class="lnr lnr-magnifier"></span>
            </div>
        </div>
        <div class="filter-row" >
            <div class="filter-description date-description">Дата проверки</div>
            <div v-if="adminGroups.length" class="filter-description group-description">Группа пользователей</div>
            <div v-if="adminGroups.length" class="filter-description user-description">Пользователь</div> 
        </div>
        <div class="filter-row">
            <div class="date-filter__holder">
                <div id="from-filter">
                    <input
                        type="text"
                        v-model="fromDate"
                        class="filter-input"
                        placeholder="от 31.12.2020"
                        maxlength="10"
                        @input="filterDateFormat($event,fromDate)"
                    />
                </div>
                <div class="filter-separator">-</div>
                <div id="to-filter">
                    <input
                        type="text"
                        v-model="toDate"
                        class="filter-input"
                        placeholder="до 31.12.2020"
                        maxlength="10"
                        @input="filterDateFormat($event,toDate)"
                    />
                </div>
            </div>
            <div v-if="adminGroups.length" id="group-filter">
                <select @change="groupFilter(chosenGroup)" v-model="chosenGroup" id="group-select" class="type add-select">
                    <option value="" disabled selected hidden>Не выбрано</option>
                    <option value="Все">Все</option>
                    <option v-bind:value="e" v-for="(e,i) in adminGroups" :key="i">{{e.title}}</option> 
                </select>
            </div>
            <div v-if="adminGroups.length" id="user-filter">
                <select @change="userFilter(chosenUser)" v-model="chosenUser" id="user-select" class="type add-select">
                    <option value="" disabled selected hidden>Не выбрано</option>
                    <option value="Все">Все</option>
                    <option v-bind:value="e" v-for="(e,i) in userNames" :key="i">{{e.user_login}} - {{e.user_name||e.user}}</option> 
                </select>
            </div>
            
        </div>
        <div class="filter-row last-row">
            <input v-model="adminRequest" type="checkbox" name="admin" id="adminRequest">
            <label for="adminRequest" class="checkbox__description">Запросы администраторов</label>
            <div class="button-row">
                <button class="refresh__button " value="Очистить" @click="refreshFilters">Сброс</button>
                <button class="form-group__button filter-button" value="Поиск" @click="sendFilterButton()">Ок</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        adminType: {
            type: String,
            required: true
        },
        onFilterCallback: {
            type: Function,
            required: true
        },
        searchPlaceholder: {
            type: String,
            required: false,
            default: "Поиск"
        }
    },
    data() {
        return {
            userNames: [],
            chosenGroup: '',
            chosenUser: '',
            stringCount: 0,
            allUserNames: [],
            idGroups: [],
            idUsers: [],
            groupEvent: '',
            userEvent: '',
            formatedFromDate: '',
            formatedToDate: '',
            allUsersIds: [],
            fromDate: '',
            toDate: '',
            userGroups: null,
            searchQuery: '',
            adminRequest: true
        }
    },
    mounted() {
        this.getGroupInfo()
    },
    methods: {
        getGroupInfo(){
            if(this.adminGroups.length) {
                const groupsIds = this.adminGroups.map(e => parseInt(e.id))
                this.userGroups = groupsIds

                this.$store.dispatch('getGroupInfo', groupsIds).then(e => {
                    if(e?.users) {
                        const users = e.users.filter((v,i,a) => a.findIndex(t => (t.user_id === v.user_id)) === i)
                        this.userNames = users
                        this.allUsersIds = users.map(e => e.user_id)
                    }
                })   
            }
        },
        groupFilter(evt) {
            if(evt != 'Все' && this.idGroups.length <= 1 ){
                let groupsContainer = this.idGroups
                this.chosenUser = ''
                if(this.idGroups.length) {
                    groupsContainer.pop()
                    groupsContainer.push(parseInt(evt.id))
                    this.idGroups = groupsContainer
                } else {
                    groupsContainer.push(parseInt(evt.id))
                    this.idGroups = groupsContainer
                }
            } else if(evt == 'Все') {
                this.idGroups = this.userGroups
            }

            if(!this.groupEvent && this.idGroups){
                this.$store.dispatch('getGroupInfo', this.idGroups).then(e => {
                    this.userNames = e.users?.filter((v,i,a) => a.findIndex(t => (t.user_id === v.user_id)) === i)
                    let userContainer = []
                    this.userNames.forEach(e => {
                        userContainer.push(e.user_id)
                    })
                    this.allUsersIds = userContainer
                })
            }
        },
        userFilter(evt) {
            this.idUsers = []
            if(evt != 'Все' && this.idUsers.length <= 1){
                let userBox = this.idUsers
                if(this.idUsers.length) {
                    userBox.pop()
                    userBox.push(parseInt(evt.user_id))
                    this.idUsers = userBox
                } else {
                    userBox.push(parseInt(evt.user_id))
                    this.idUsers = userBox
                }
            } else if(evt == 'Все') {
                this.idUsers = this.allUsersIds
            }
        },
        refreshFilters() {
            this.chosenUser = ''
            this.chosenGroup = ''
            this.toDate = ''
            this.fromDate = ''
            // this.userNames = this.allUserNames
            this.searchQuery = ''
            this.idUsers = []
            this.idGroups = []
            this.$props.onFilterCallback()
            this.$emit('history-refresh')
        },
        sendFilterButton() {
            if(this.fromDate || this.toDate || this.idGroups || this.idUsers) {
                let formatedFromDate = ''
                let formatedToDate = ''

                if(this.fromDate) {
                    let arrForFromDate = this.fromDate.split('.')
                    formatedFromDate = `${arrForFromDate[2]}-${arrForFromDate[1]}-${arrForFromDate[0]}`
                }
                
                if(this.toDate) {
                    let arrForToDate = this.toDate.split('.')
                    formatedToDate = `${arrForToDate[2]}-${arrForToDate[1]}-${arrForToDate[0]}`
                }

                this.$props.onFilterCallback(0, 50, this.searchQuery, this.idUsers, formatedFromDate, formatedToDate)
            }
        },
        filterDateFormat(evt, model){ 
            let inputString = evt.target.value
            let result = true
            if(model == this.toDate){
                this.toDate = evt.target.value.replace(/[^0-9.]/g, '')

                if (inputString.length < this.stringCount) {
                    this.stringCount = inputString.length
                    result = false	
                }

                if (inputString.length === 2 && result) {
                    evt.target.value += '.'
                    this.stringCount = inputString.length + 1
                    this.toDate = evt.target.value	
                }

                if (inputString.length === 5 && result) {
                    evt.target.value += '.'
                    this.stringCount = inputString.length + 1
                    this.toDate = evt.target.value
                }

                result = true
            } else if(model == this.fromDate) {
                this.fromDate = evt.target.value.replace(/[^0-9.]/g, '')

                if (inputString.length < this.stringCount) {
                    this.stringCount = inputString.length
                    result = false
                }

                if (inputString.length === 2 && result) {
                    evt.target.value += '.'
                    this.stringCount = inputString.length + 1
                    this.fromDate = evt.target.value	
                }

                if (inputString.length === 5 && result) {
                    evt.target.value += '.'
                    this.stringCount = inputString.length + 1
                    this.fromDate = evt.target.value
                }
                result = true
            }
        }
    },
    computed: {
        adminGroups() {
            return this.$store.state.user.groups.filter(e => e.rules[this.$props.adminType])
        }
    },
    watch:{
        adminRequest(){
            this.$emit("admin-request" , this.adminRequest)
        },
    }
}
</script>

<style lang="sass" scoped>
.filter-table
    width: 100%

    #group-select
        width: 280px

    #user-select
        width: 406px

    .table-column
        padding-left: 10px !important

    .search-header
        padding-top: 15px
        font-size: 14px
        font-weight: 500

    .button-row
        text-align: right
        margin-left: 51.5%

    .filter-separator
        // margin-top: 0 !important
        padding-top: 5px
        font-weight: 300
        font-size: 12px
        // color: #b8b8b8

    .date-description
        margin-left: 0 !important

    .group-description
        margin-left: 140px !important

    .user-description
        margin-left: 105px !important

    .last-row
        margin-bottom: 30px !important

    .lnr-cross
        cursor: pointer
        position: absolute
        right: 50px
        font-size: 26px
        bottom: 25px
    .lnr-magnifier
        cursor: pointer
        position: absolute
        right: 15px
        font-size: 26px
        bottom: 25px
    .filter-row
        display: flex
        margin: 10px 0

    .date-filter__holder
        display: flex

    .refresh__button
        display: inline-block
        vertical-align: top
        text-align: center
        font-weight: 500
        font-size: 14px
        color: #333
        background:transparent
        border: 0
        border-radius: 5px
        cursor: pointer
        margin: 0 10px
        width: 112px
        height: 34px
        line-height: 34px

    .refresh__button:active
        color: #484747
        background-color: #a7baf9

    #group-filter 
        margin-left: 15px

    #user-filter
        margin-left: 15px

    .filter-header 
        padding-top: 8px
        font-size: 14px
        font-weight: 500

    .filter-description
        font-size: 14px
        padding-top: 8px
        margin: 0 25px
        font-weight: 400

    .type
        height: 30px !important

    .filter-input
        width: 125px
        margin-bottom: 5px
        min-height: 30px
        border-radius: 3px
        padding: 4px 8px
        border: 1px solid #b8b8b8
        box-shadow: none
        text-align: left

    .add-select 
        width: 395px
        border: 1px solid #b8b8b8
        border-radius: 4px
        font-size: 14px

    .add-select 
        option
            font-size: 14px

    .monitoring__content-search-block
        width: 100%
        position: relative

    .monitoring__content-search
        margin-top: 15px
        margin-bottom: 15px
        background: rgba(173, 203, 252, 0.46)
        width: 100%
        height: 46px
        line-height: 46px
        border-radius: 6px
        border: 0
        padding: 0 20px

    .filters-holder
        float: right
        display: block
        margin: 20px 170px 0 0

    .form-group__button 
        display: inline-block
        vertical-align: top
        width: 112px
        height: 34px
        text-align: center
        line-height: 34px
        color: #fff
        font-weight: 500
        font-size: 14px
        background-color: #4771f3
        border: 0
        border-radius: 5px
        cursor: pointer

    .filters-holder button
        margin: 10px 0 0 0

    .form-group__button:active 
        color: #484747
        background-color: #a7baf9

    input[type="checkbox"]
        margin-top: 12px
        cursor: pointer

    .checkbox__description
        cursor: pointer
        margin-top: 12px
        margin-left: 5px
        font-size: 14px
        font-weight: 500
        text-align: left

@media screen and (max-width: 1280px)
    .button-row
        margin-left: 39.5% !important
    .group-description
        margin-left: 80px !important
    .user-description
        margin-left: 54px !important
    .filter-input
        width: 95px 
    #group-select
        width: 230px
    #user-select
        width: 322px
</style>